import React, { Component } from 'react';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import Pagination from '../../Common/Pagination';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import { ephotobookDataList } from '../../Common/Providers/EPhotobookApi';
import { EPhotobookLineItem, EmptyEPhotobookContent } from './ViewComp';
import { OWNER, SHARED } from './Constants';
import SearchSpinner from '../../Common/SpinnerWithoutOverlay';

class EPhotobook extends Component {
  render() {
    if (!this.props.isLoaded) {
      return (
          <div className='dashboard-card p-3 p-lg-5'>
            <SearchSpinner />
          </div>
      );
    }

    const {
      getData,
      lastPage,
      currentPage,
      currentSelectedType,
      ephotobookList,
      onClickType
    } = this.props;

    const TypeBar = () => {
      const myShareItBtnClass = (currentSelectedType === OWNER)
        ? 'btn btn-primary'
        : 'btn btn-outline-primary';
      const sharedWithMeBtnClass = (currentSelectedType === SHARED)
        ? 'btn btn-primary'
        : 'btn btn-outline-primary';

      const myShareItText = <HTMLTrans id='account.btn_my_share_it_filter'>My Share It</HTMLTrans>; 
      const sharedWithMeText = <HTMLTrans id='account.btn_shared_with_me_filter'>Shared With Me</HTMLTrans>; 

      return (
              <div>
                  <div className='col-lg-6 col-sm-12 p-0'>
                      <div className='btn-group btn-group-sm d-flex' role='group'>
                          <button type='button' className={`${myShareItBtnClass} w-100 my-share-it`}
                                  onClick={() => onClickType(OWNER)}>{myShareItText}</button>
                          <button type='button' className={`${sharedWithMeBtnClass} w-100 shared-with-me`}
                                  onClick={() => onClickType(SHARED)}>{sharedWithMeText}</button>
                      </div>
                  </div>
              </div>
      );
    };

    const EPhotobookItems = () => (
          <div className="container my-5">
            <div className='ephotobook'>
                {ephotobookList.map((item, index) => (
                  <EPhotobookLineItem
                    item={item}
                    key={`ephotobook-pagination-list-${index}-page-${currentPage}`}
                    index= {index}
                    currentPage={currentPage}
                    currentSelectedType={currentSelectedType}
                  />
                ))}
            </div>
          </div>
    );

    return (
        <div className="dashboard-card p-3 p-lg-5">
            <h3><HTMLTrans id="account.ephotobook_heading">Share It</HTMLTrans></h3>
            <hr />
            <TypeBar />
            {(ephotobookList.length < 1) ? <EmptyEPhotobookContent /> : <EPhotobookItems /> }
            <Pagination lastPageNumber={lastPage}
                        currentPageNumber={currentPage}
                        onClick={getData}/>
        </div>
    );
  }
}

const enhance = compose(
  withTranslationProvider,
  withState('ephotobookList', 'setEPhotobookList', []),
  withState('lastPage', 'setLastPage', 1),
  withState('currentPage', 'setCurrentPage', 1),
  withState('isLoaded', 'setIsLoaded', false),
  withState('currentSelectedType', 'setCurrentSelectedType', OWNER),
  withHandlers({
    getData: ({ setEPhotobookList, setLastPage, setCurrentPage, setIsLoaded, setCurrentSelectedType, currentSelectedType, t}) => (page, type = currentSelectedType) => {
      setCurrentSelectedType(type);
      setIsLoaded(false);
      window.scrollTo(0, 0);
      ephotobookDataList({ page, type })
        .done((response) => {
          window.scrollTo(0, 0);
          setEPhotobookList(response.data.ephotobooks);
          setLastPage(response.data.pagination.last_page);
          setCurrentPage(response.data.pagination.current_page);
          setIsLoaded(true);
        })
        .fail(response => toastr.error(t('account.ephotobook_ephotobookdata_getlistdata_fail', 'Something went wrong, please reload again.')));
    },
  }),
  withHandlers({
    onClickType: ({ currentSelectedType, getData }) => (type) => {
      if (currentSelectedType !== type) {
        getData(1, type);
      }
    }
  }),
  lifecycle({
    componentDidUpdate() {
      this.shouldCallApi = window.location.pathname.includes('ephotobook');
      if(this.shouldCallApi && !this.didCallApi) {
        this.didCallApi = true;
        this.props.getData(1);
      }
    }
  }),
);

export default enhance(EPhotobook);
export const undecorated = EPhotobook;



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/EPhotobook.js